import React, { useEffect, useState, useRef } from "react";
import './NikeProducts.css';
import Item from "../Item/Item";

const NikeProducts = () => {
  const [nikeProducts, setNikeProducts] = useState([]);
  const productsListRef = useRef(null);

  useEffect(() => {
    fetch('/api/nikeproducts')
      .then((response) => response.json())
      // Fetching more items so the carousel feels full
      .then((data) => setNikeProducts(data.slice(0, 10))) 
      .catch((error) => console.error('Error fetching Nike products:', error));
  }, []);

  const scroll = (scrollOffset) => {
    if (productsListRef.current) {
      // Calculate a dynamic scroll amount based on one item's width
      const itemWidth = productsListRef.current.querySelector('.carousel-item-container').offsetWidth;
      const newScrollOffset = (itemWidth + 24) * 3 * Math.sign(scrollOffset); // Scroll by 3 items
      productsListRef.current.scrollBy({ left: newScrollOffset, behavior: 'smooth' });
    }
  };

  return (
    // The main section is now full-width (no .container class)
    <section className="product-carousel"> 
      <div className="brand-ribbon">
          <div className="brand-ribbon__track">
              {Array(10).fill().map((_, i) => (
                  <span key={i} className="brand-ribbon__text">NIKE</span>
              ))}
          </div>
      </div>

      {/* We keep the header inside a .container to keep it centered */}
      <div className="container">
        <div className="product-carousel__header">
          <h2>NIKE</h2>
        </div>
      </div>
      
      {/* This wrapper is now full-width */}
      <div className="product-carousel__list-wrapper">
        <div className="product-carousel__list" ref={productsListRef}>
          {nikeProducts.length > 0 ? (
            nikeProducts.map((item) => (
              <div className="carousel-item-container" key={item.id}>
                <Item 
                  id={item.id} 
                  name={item.name} 
                  image={item.image} 
                  new_price={item.new_price} 
                  old_price={item.old_price} 
                />
              </div>
            ))
          ) : (
            <div className="spinner-container">
              <div className="spinner"></div>
            </div>
          )}
        </div>
        
        <button className="carousel-button carousel-button--left" onClick={() => scroll(-1)} aria-label="Scroll left">
          {'<'}
        </button>
        <button className="carousel-button carousel-button--right" onClick={() => scroll(1)} aria-label="Scroll right">
          {'>'}
        </button>
      </div>
    </section>
  );
}

export default NikeProducts;